import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { MetaHead } from '../components/MetaHead';
export const PoliticaPrivacidad = () => {
  return <div className="font-sans bg-[#FDF8F3] text-[#333333] min-h-screen" data-id="element-376">
      <MetaHead data-id="element-377" />
      <header className="bg-[#0C1B2A] text-white py-3 px-4 sm:px-6 flex justify-between items-center" data-id="element-378">
        <Link to="/" className="text-xl font-serif font-bold flex items-center" data-id="element-379">
          <svg className="w-6 h-6 text-[#D4AF37] mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-380">
            <path d="M21.5 14.0784C21.5 16.8437 19.2645 19.1187 16.5384 19.1187C16.1124 19.1187 15.7002 19.0646 15.3078 18.9635C14.9654 19.3366 14.3466 19.8975 13.5371 20.3226C12.7275 20.7477 11.7099 21 11 21C11 21 11.7635 20.0814 11.5371 19.1187C9.48137 18.4286 8 16.4155 8 14.0784C8 11.3131 10.2355 9.03809 12.9616 9.03809C15.6877 9.03809 17.9232 11.3131 17.9232 14.0784C17.9232 14.9678 17.7365 15.8572 17.3941 16.6301C17.7365 16.7311 18.1255 16.7852 18.5 16.7852C18.5 16.7852 18.0718 16.2783 18.1904 15.7715C18.4843 15.2646 18.6318 14.6847 18.6318 14.0784C18.6318 12.8162 18.1255 11.6621 17.2674 10.8081C16.4093 9.9541 15.2839 9.44724 14.0391 9.44724C12.7943 9.44724 11.6689 9.9541 10.8108 10.8081C9.95269 11.6621 9.44645 12.8162 9.44645 14.0784C9.44645 15.1785 9.8374 16.1761 10.5459 16.9219C9.95269 17.1782 9.21476 17.3062 8.5 17.3062C8.5 17.3062 9.00624 17.7312 9.00624 18.2381C9.00624 18.7449 8.5 19.1699 8.5 19.1699C9.21476 19.1699 10.2324 18.9135 11.042 18.4887C11.8515 18.0636 12.4703 17.5027 12.8127 17.1296C13.2051 17.2307 13.6173 17.2848 14.0433 17.2848C15.2881 17.2848 16.4135 16.778 17.2716 15.9239C18.1297 15.0699 18.6359 13.9158 18.6359 12.6536C18.6359 11.3914 18.1297 10.2373 17.2716 9.38332C16.4135 8.52935 15.2881 8.0225 14.0433 8.0225C12.7985 8.0225 11.6731 8.52935 10.815 9.38332C9.95691 10.2373 9.45066 11.3914 9.45066 12.6536C9.45066 12.7006 9.45066 12.7546 9.45487 12.8027C7.93649 13.4117 6.86103 14.9678 6.86103 16.7852C6.86103 19.1699 8.71328 21.0541 11.042 21.0541C11.042 21.0541 10.2786 20.1355 10.505 19.1728C12.5607 18.4827 14.0421 16.4696 14.0421 14.1325C14.0421 11.3672 11.8066 9.09221 9.08046 9.09221C6.35432 9.09221 4.11883 11.3672 4.11883 14.1325C4.11883 16.8978 6.35432 19.1728 9.08046 19.1728C9.50647 19.1728 9.91868 19.1187 10.3111 19.0176C10.6535 19.3907 11.2723 19.9516 12.0818 20.3767C12.8914 20.8018 13.909 21.0541 14.6189 21.0541C14.6189 21.0541 13.8554 20.1355 14.0818 19.1728C16.1375 18.4827 17.6189 16.4696 17.6189 14.1325" fill="#D4AF37" data-id="element-381" />
          </svg>
          Guía Contra el Mal de Ojo
        </Link>
        <Link to="/" className="text-sm text-white hover:text-[#D4AF37] transition-colors duration-300" data-id="element-382">
          Volver al inicio
        </Link>
      </header>
      <main className="py-12 px-4 sm:px-6 md:px-8 max-w-4xl mx-auto" data-id="element-383">
        <h1 className="font-serif text-3xl font-bold text-[#0C1B2A] mb-8" data-id="element-384">
          Política de Privacidad
        </h1>
        <div className="prose prose-slate max-w-none" data-id="element-385">
          <p className="mb-4" data-id="element-386">
            <strong data-id="element-387">Última actualización:</strong>{' '}
            {new Date().toLocaleDateString()}
          </p>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-388">1. Introducción</h2>
          <p className="mb-4" data-id="element-389">
            Guía Contra el Mal de Ojo ("nosotros", "nuestro" o "nos") se
            compromete a proteger su privacidad. Esta Política de Privacidad
            explica cómo recopilamos, usamos y protegemos su información
            personal cuando utiliza nuestro sitio web y compra nuestro eBook.
          </p>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-390">
            2. Información que recopilamos
          </h2>
          <p className="mb-4" data-id="element-391">
            Podemos recopilar los siguientes tipos de información:
          </p>
          <ul className="list-disc pl-6 mb-4" data-id="element-392">
            <li data-id="element-393">
              <strong data-id="element-394">Información personal:</strong> Nombre, dirección de correo
              electrónico, información de facturación cuando realiza una compra.
            </li>
            <li data-id="element-395">
              <strong data-id="element-396">Información de uso:</strong> Cómo interactúa con nuestro
              sitio web, incluyendo las páginas visitadas, el tiempo que pasa en
              ellas y los enlaces en los que hace clic.
            </li>
            <li data-id="element-397">
              <strong data-id="element-398">Información técnica:</strong> Dirección IP, tipo de
              navegador, proveedor de servicios de Internet, páginas de
              referencia/salida, sistema operativo, fecha/hora y datos de
              clickstream.
            </li>
          </ul>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-399">
            3. Cómo utilizamos su información
          </h2>
          <p className="mb-4" data-id="element-400">
            Utilizamos la información que recopilamos para:
          </p>
          <ul className="list-disc pl-6 mb-4" data-id="element-401">
            <li data-id="element-402">Procesar y completar sus transacciones</li>
            <li data-id="element-403">Enviarle el eBook y los materiales relacionados</li>
            <li data-id="element-404">
              Enviarle información sobre actualizaciones, ofertas especiales o
              servicios relacionados
            </li>
            <li data-id="element-405">Mejorar nuestro sitio web y experiencia del usuario</li>
            <li data-id="element-406">Entender la efectividad de nuestras campañas de marketing</li>
            <li data-id="element-407">Cumplir con obligaciones legales</li>
          </ul>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-408">
            4. Cookies y tecnologías similares
          </h2>
          <p className="mb-4" data-id="element-409">
            Utilizamos cookies y tecnologías similares para recopilar
            información sobre su actividad, navegador y dispositivo. Puede
            configurar su navegador para rechazar todas las cookies o para
            indicar cuándo se está enviando una cookie. Sin embargo, si no
            acepta cookies, es posible que algunas partes de nuestro sitio no
            funcionen correctamente.
          </p>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-410">
            5. Compartir su información
          </h2>
          <p className="mb-4" data-id="element-411">
            No vendemos, comerciamos ni transferimos de otro modo su información
            personal a terceros externos sin su consentimiento, excepto en las
            siguientes circunstancias:
          </p>
          <ul className="list-disc pl-6 mb-4" data-id="element-412">
            <li data-id="element-413">
              Proveedores de servicios que nos ayudan con nuestras operaciones
              comerciales (como procesamiento de pagos o entrega de correos
              electrónicos)
            </li>
            <li data-id="element-414">
              Cuando sea necesario para cumplir con la ley, hacer cumplir
              nuestras políticas del sitio o proteger nuestros derechos,
              propiedad o seguridad
            </li>
          </ul>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-415">
            6. Seguridad de los datos
          </h2>
          <p className="mb-4" data-id="element-416">
            Implementamos medidas de seguridad diseñadas para proteger su
            información personal. Sin embargo, ningún método de transmisión por
            Internet o método de almacenamiento electrónico es 100% seguro, por
            lo que no podemos garantizar su seguridad absoluta.
          </p>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-417">7. Sus derechos</h2>
          <p className="mb-4" data-id="element-418">
            Dependiendo de su ubicación, puede tener ciertos derechos
            relacionados con su información personal, como:
          </p>
          <ul className="list-disc pl-6 mb-4" data-id="element-419">
            <li data-id="element-420">Acceder a la información personal que tenemos sobre usted</li>
            <li data-id="element-421">Corregir información inexacta o incompleta</li>
            <li data-id="element-422">Solicitar la eliminación de su información personal</li>
            <li data-id="element-423">
              Oponerse o restringir el procesamiento de su información personal
            </li>
            <li data-id="element-424">Solicitar la portabilidad de sus datos</li>
          </ul>
          <p className="mb-4" data-id="element-425">
            Para ejercer estos derechos, contáctenos a través del formulario en
            nuestra página web.
          </p>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-426">
            8. Cambios a esta política
          </h2>
          <p className="mb-4" data-id="element-427">
            Podemos actualizar nuestra Política de Privacidad de vez en cuando.
            Le notificaremos cualquier cambio publicando la nueva Política de
            Privacidad en esta página y, si los cambios son significativos, le
            enviaremos una notificación por correo electrónico.
          </p>
          <h2 className="text-xl font-semibold mt-8 mb-4" data-id="element-428">9. Contacto</h2>
          <p className="mb-4" data-id="element-429">
            Si tiene preguntas sobre esta Política de Privacidad, contáctenos a
            través del formulario en nuestra página web.
          </p>
        </div>
      </main>
      <Footer data-id="element-430" />
    </div>;
};